import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'account-code-edit-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class AccountCodeEdit implements OnInit {
  public form: FormGroup;

  constructor(
    protected dialogRef: MatDialogRef<AccountCodeEdit>,
    @Inject(MAT_DIALOG_DATA) public config
  ) {}

  ngOnInit(): void {
    const { Organisation } = this.config;
    const formBuilder = new FormBuilder();
    this.form = formBuilder.group({
      account_id: [null, null],
    });

    if (Organisation) {
      Object.keys(Organisation).forEach((name) => {
        if (this.form.controls[name]) {
          this.form.controls[name].patchValue(Organisation[name]);
        }
      });
    }
  }

  onSubmit() {
    const accountCode = {
      ...this.form.getRawValue(),
      id: this.config.Organisation.company_id,
    };
    this.form.disable();
    this.config.OrganisationDataSource.updateAccountCode(accountCode).then(() =>
      this.dialogRef.close()
    );
  }
}
